<template>
  <div>
    <b-card class="standardpage reports">
      <b-card-header class="px-3">
        <b-row align-h="between">
          <b-col cols="auto" class="text-sm-left pt-1">
            <i :class="reports.icon" class="mr-1"></i>
            {{ instance.name }}
          </b-col>
          <b-col cols="auto" class="">
            <i v-if="item.comment" id="tooltip-report" class="fa fa-info-circle fa-2x"></i></b-col>
          <b-col class="text-right">
            <b-button v-if="showback" squared size="sm" variant="outline-primary" @click="$emit('discard')">
              <i class="fa fa-chevron-left pr-1"></i>Back
            </b-button>
          </b-col>
          <b-tooltip v-if="item.comment" target="tooltip-report" triggers="hover" placement="right">
            {{ item.comment }}
          </b-tooltip>
        </b-row>

      </b-card-header>
      <b-card-body class="px-0">
        <b-card v-if="showfilter" no-body class="pt-2 pl-3 mb-2">
          <b-card-text>
            <!-- <p v-if="item.requirement" class="small text-danger">
              Please input {{ item.requirement }} to display report.
            </p> -->
            <section>

              <b-row class="w-100pct">
                <b-col cols="12" md="3" v-for="(filter, index) in reports.filters_standard" :key="index">
                  <b-form-group :label="label(filter)" label-cols="12" label-size="sm">

                    <b-input-group v-if="filter.info" class="treeselect_all"
                      :style="'left:' + (95 + filter.label.length) + 'px; top:-13px'">
                      <i :id="'info' + filter.key" class="fa fa-info-circle text-black"></i>
                    </b-input-group>
                    <b-tooltip v-if="filter.info" :target="'info' + filter.key" triggers="hover" placement="top">{{
                      filter.info }}
                    </b-tooltip>

                    <b-input-group>
                      <treeselect v-if="filter.type == 'treeselect' && filter.key == 'snapshot'
                      " :disabled="busyddl" :clearable="false" v-model="reports.args[filter.key]"
                        :options="snapshot_options" :placeholder="filter.placeholder" />

                      <treeselect v-if="filter.type == 'treeselect' &&
                        (filter.key == 'event' || filter.key == 'eventcode')
                      " :searchPromptText="filter.searchPromptText
                        ? filter.searchPromptText
                        : 'Type at least 4 chars...'
                        " :multiple="filter.multiple == true ? true : false" :async="true" :show-count="true"
                        :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                        :load-options="treeselect_loadEvent" v-model="reports.args[filter.key]">
                        <div slot="value-label" slot-scope="{ node }">
                          {{ node.raw.id }}
                        </div>
                      </treeselect>

                      <treeselect v-if="filter.type == 'treeselect' && filter.key == 'slac' && !filter.options"
                        :searchPromptText="filter.searchPromptText
                          ? filter.searchPromptText
                          : 'Type at least 3 chars...'
                          " :multiple="filter.multiple == true ? true : false" :async="true" :show-count="true"
                        :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                        :load-options="treeselect_loadSLAC" v-model="reports.args[filter.key]">
                        <div slot="value-label" slot-scope="{ node }">
                          {{ node.raw.id }}
                        </div>
                      </treeselect>

                      <treeselect v-if="filter.type == 'treeselect' && filter.key == 'blac'
                      " :searchPromptText="filter.searchPromptText
                        ? filter.searchPromptText
                        : 'Type at least 3 chars...'
                        " :multiple="filter.multiple == true ? true : false" :async="true" :show-count="true"
                        :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                        :load-options="treeselect_loadBLAC" v-model="reports.args[filter.key]">
                        <div slot="value-label" slot-scope="{ node }">
                          {{ node.raw.id }}
                        </div>
                      </treeselect>

                      <treeselect v-if="filter.type == 'treeselect' &&
                        filter.key == 'operatingcarrier'
                      " :searchPromptText="filter.searchPromptText
                        ? filter.searchPromptText
                        : 'Type at least 2 chars...'
                        " :multiple="filter.multiple == true ? true : false" :async="true" :show-count="true"
                        :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                        :load-options="treeselect_loadAirline" v-model="reports.args[filter.key]">
                        <div slot="value-label" slot-scope="{ node }">
                          {{ node.raw.id }}
                        </div>
                      </treeselect>

                      <treeselect v-if="filter.type == 'treeselect' && filter.key == 'nlcode'
                      " :multiple="filter.multiple == true ? true : false" raw :show-count="true"
                        :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                        :options="nlcode_options" v-model="reports.args[filter.key]">
                        <div slot="value-label" slot-scope="{ node }">
                          {{ node.raw.id }}
                        </div>
                      </treeselect>

                      <div v-if="filter.type == 'treeselect' && filter.key == 'emdremark'">
                        remarks = {{ emdremarks_options }}
                      </div>
                      <treeselect v-if="filter.type == 'treeselect' && filter.key == 'emdremark'
                      " :multiple="filter.multiple == true ? true : false" raw :show-count="true"
                        :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                        :options="emdremarks_options" v-model="reports.args[filter.key]">
                        <div slot="value-label" slot-scope="{ node }">
                          {{ node.raw.id }}
                        </div>
                      </treeselect>

                      <treeselect v-if="filter.type == 'treeselect' && filter.key == 'budgetcode'
                      " :multiple="filter.multiple == true ? true : false" raw :show-count="true"
                        :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                        :options="budgetcode_options" v-model="reports.args[filter.key]">
                        <div slot="value-label" slot-scope="{ node }">
                          {{ node.raw.id }}
                        </div>
                      </treeselect>

                      <treeselect v-if="filter.type == 'treeselect' && filter.key == 'stypecode'
                      " :multiple="filter.multiple == true ? true : false" raw :show-count="true"
                        :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                        :options="stypecode_options" v-model="reports.args[filter.key]">
                        <div slot="value-label" slot-scope="{ node }">
                          {{ node.raw.id }}
                        </div>
                      </treeselect>

                      <treeselect v-if="filter.type == 'treeselect' && filter.key == 'salesgroup'
                      " :multiple="filter.multiple == true ? true : false" raw :show-count="true"
                        :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                        :options="salesgroup_options" v-model="reports.args[filter.key]">
                        <div slot="value-label" slot-scope="{ node }">
                          {{ node.raw.id }}
                        </div>
                      </treeselect>

                      <treeselect v-if="filter.type == 'treeselect' && filter.key == 'accounttype'
                      " :multiple="filter.multiple == true ? true : false" raw :show-count="true"
                        :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                        :options="accounttype_options" v-model="reports.args[filter.key]">
                        <div slot="value-label" slot-scope="{ node }">
                          {{ node.raw.id }}
                        </div>
                      </treeselect>


                      <treeselect v-if="filter.type == 'treeselect' && filter.key == 'slacgroup'
                      " :multiple="filter.multiple == true ? true : false" raw :show-count="true"
                        :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                        :options="slacgroup_options" v-model="reports.args[filter.key]">
                        <div slot="value-label" slot-scope="{ node }">
                          {{ node.raw.id }}
                        </div>
                      </treeselect>

                      <treeselect v-if="filter.type == 'treeselect' && filter.options"
                        :multiple="filter.multiple == true ? true : false" :show-count="true"
                        :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                        :options="filter.options" :placeholder="filter.placeholder" v-model="reports.args[filter.key]">
                      </treeselect>

                      <treeselect v-if="filter.key == 'monthof'" :disabled="busyddl" :clearable="false"
                        v-model="reports.args[filter.key]" :options="filter.options"
                        :placeholder="filter.placeholder" />

                      <daterangepicker v-if="filter.type == 'daterangepicker'" v-model="reports.args[filter.key]"
                        :opens="'right'" :single-date-picker="'range'" :locale-data="locale_data" :ranges="instance.call == 'report_nltrial'
                          ? finance_ranges
                          : locale_ranges
                          " :linkedCalendars="true" :showDropdowns="true">
                      </daterangepicker>

                      <daterangepicker v-if="filter.type == 'daterangepicker2'" v-model="reports.args[filter.key]"
                        :opens="'right'" :single-date-picker="false" :locale-data="locale_data" :ranges="instance.call == 'report_nltrial'
                          ? finance_ranges
                          : locale_ranges
                          " :linkedCalendars="false" :showDropdowns="true">
                      </daterangepicker>

                      <v-date-picker v-if="filter.type == 'dateinput'" v-model="reports.args[filter.key]" mode="date"
                        is24hr color="green" :locale="'en-gb'" class="form-control form-control-sm">
                        <template v-slot="{ inputValue, inputEvents }">
                          <input class="
                              h-20px
                              border-none
                              focus:outline-none focus:border-primary
                              text-primary
                            " :value="inputValue" v-on="inputEvents" />
                        </template>
                      </v-date-picker>

                      <b-form-input v-if="filter.type == 'b-form-input'" type="text" v-model="reports.args[filter.key]"
                        :placeholder="placeholder(filter)" :disabled="filter.disabled" size="sm" trim
                        :debounce="reports.debounce"></b-form-input>

                      <b-form-textarea v-if="filter.type == 'b-form-textarea'" type="text"
                        v-model="reports.args[filter.key]" :placeholder="placeholder(filter)"
                        :disabled="filter.disabled" size="sm" trim :debounce="reports.debounce"></b-form-textarea>

                      <b-form-tags v-if="filter.type == 'b-form-tags'" v-model="reports.args[filter.key]"
                        tag-variant="primary" separator=" ,;" :placeholder="placeholder(filter)"
                        :disabled="filter.disabled" size="sm" class="h-29" add-button-text="+" add-on-change
                        remove-on-delete add-button-variant="outline-primary" trim
                        :debounce="reports.debounce"></b-form-tags>
                      <!-- {{filter.options}} -->
                      <!-- "{ year: 'numeric', month: 'numeric', day: 'numeric' }" -->
                      <b-form-datepicker v-if="filter.type == 'b-form-datepicker'" v-model="reports.args[filter.key]"
                        size="sm" label-help hide-header locale="en-GB" :placeholder="filter.placeholder
                          ? filter.placeholder
                          : 'Select date'
                          " :disabled="filter.disabled" :date-format-options="filter.options
                            ? filter.options
                            : {
                              year: 'numeric',
                              month: 'numeric',
                              day: 'numeric',
                            }
                            " :debounce="reports.debounce"></b-form-datepicker>
                      <!-- "[{ text: 'Sold Only', value: true }, { text: 'Show All', value: false }]" -->
                      <!-- {{filter.key}} -->

                      <!-- <b-input-group v-if="filter.type == 'dateinputbutton'"> -->
                      <b-input-group-prepend v-if="filter.type == 'dateinputbutton'">
                        <b-form-datepicker size="sm" v-model="reports.args[filter.key]" button-only label-help=""
                          locale="en-GB" :disabled="filter.disabled" :date-format-options="filter.options
                            ? filter.options
                            : {
                              year: 'numeric',
                              month: 'numeric',
                              day: 'numeric',
                            }
                            "></b-form-datepicker>
                      </b-input-group-prepend>
                      <b-form-input v-if="filter.type == 'dateinputbutton'" size="sm" v-model="reports.args[filter.key]"
                        type="text" placeholder="DD/MM/YY" autocomplete="off"
                        :disabled="filter.disabled"></b-form-input>

                      <!--</b-input-group> -->

                      <b-form-radio-group v-if="filter.type == 'b-form-radio-group'" v-model="reports.args[filter.key]"
                        :options="filter.options" buttons button-variant="outline-success" size="sm"
                        name="radio-btn-outline" :debounce="reports.debounce"></b-form-radio-group>
                      <b-input-group-append v-if="filter.clearable &&
                        filter.type != 'treeselect' &&
                        filter.type != 'b-form-radio-group'
                      ">
                        <b-button v-if="filter.type == 'daterangepicker' || filter.type == 'daterangepicker2'" size="sm"
                          variant="outline-secondary" @click="
                            reports.args[filter.key] = {
                              startDate: null,
                              endDate: null,
                            }
                            ">
                          <i class="fa fa-remove"></i>
                        </b-button>
                        <b-button v-if="!(filter.type == 'daterangepicker' || filter.type == 'daterangepicker2')"
                          size="sm" variant="outline-secondary" @click="reports.args[filter.key] = null">
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row class="w-100pct mt-2" v-if="reports.filters_advanced.length > 0">
                <b-col cols="12">
                  <i class="fa fa-filter text-primary"></i>
                  <b-link @click="advanced = !advanced" class="ml-2" variant="primary"
                    v-text="advanced ? 'Less filters...' : 'More filters...'"></b-link>

                  <b-collapse v-model="advanced" id="collapse-1" class="mt-3">
                    <b-row>
                      <b-col cols="12" md="3" v-for="(filter, index) in reports.filters_advanced" :key="index">
                        <b-form-group :label="label(filter)" label-cols="12" label-size="sm">
                          <b-input-group>
                            <treeselect v-if="filter.type == 'treeselect' && filter.key == 'snapshot'
                            " :disabled="busyddl" :clearable="false" v-model="reports.args[filter.key]"
                              :options="snapshot_options" :placeholder="filter.placeholder" />

                            <treeselect v-if="filter.type == 'treeselect' &&
                              (filter.key == 'event' || filter.key == 'eventcode')
                            " :searchPromptText="filter.searchPromptText
                              ? filter.searchPromptText
                              : 'Type at least 4 chars...'
                              " :multiple="filter.multiple == true ? true : false" :async="true" :show-count="true"
                              :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                              search-nested :load-options="treeselect_loadEvent" v-model="reports.args[filter.key]">
                              <div slot="value-label" slot-scope="{ node }">
                                {{ node.raw.id }}
                              </div>
                            </treeselect>

                            <treeselect v-if="filter.type == 'treeselect' && filter.key == 'slac'
                            " :searchPromptText="filter.searchPromptText
                              ? filter.searchPromptText
                              : 'Type at least 3 chars...'
                              " :multiple="filter.multiple == true ? true : false" :async="true" :show-count="true"
                              :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                              search-nested :load-options="treeselect_loadSLAC" v-model="reports.args[filter.key]">
                              <div slot="value-label" slot-scope="{ node }">
                                {{ node.raw.id }}
                              </div>
                            </treeselect>

                            <treeselect v-if="filter.type == 'treeselect' && filter.key == 'blac'
                            " :searchPromptText="filter.searchPromptText
                              ? filter.searchPromptText
                              : 'Type at least 3 chars...'
                              " :multiple="filter.multiple == true ? true : false" :async="true" :show-count="true"
                              :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                              search-nested :load-options="treeselect_loadBLAC" v-model="reports.args[filter.key]">
                              <div slot="value-label" slot-scope="{ node }">
                                {{ node.raw.id }}
                              </div>
                            </treeselect>

                            <treeselect v-if="filter.type == 'treeselect' &&
                              filter.key == 'operatingcarrier'
                            " :searchPromptText="filter.searchPromptText
                              ? filter.searchPromptText
                              : 'Type at least 2 chars...'
                              " :multiple="filter.multiple == true ? true : false" :async="true" :show-count="true"
                              :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                              search-nested :load-options="treeselect_loadAirline" v-model="reports.args[filter.key]">
                              <div slot="value-label" slot-scope="{ node }">
                                {{ node.raw.id }}
                              </div>
                            </treeselect>

                            <treeselect v-if="filter.type == 'treeselect' && filter.key == 'nlcode'
                            " :multiple="filter.multiple == true ? true : false" raw :show-count="true"
                              :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                              search-nested :options="nlcode_options" v-model="reports.args[filter.key]">
                              <div slot="value-label" slot-scope="{ node }">
                                {{ node.raw.id }}
                              </div>
                            </treeselect>

                            <treeselect v-if="filter.type == 'treeselect' && filter.key == 'emdremark'
                            " :multiple="filter.multiple == true ? true : false" raw :show-count="true"
                              :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                              search-nested :options="emdremarks_options" v-model="reports.args[filter.key]">
                              <div slot="value-label" slot-scope="{ node }">
                                {{ node.raw.id }}
                              </div>
                            </treeselect>

                            <treeselect v-if="filter.type == 'treeselect' && filter.key == 'budgetcode'
                            " :multiple="filter.multiple == true ? true : false" raw :show-count="true"
                              :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                              search-nested :options="budgetcode_options" v-model="reports.args[filter.key]">
                              <div slot="value-label" slot-scope="{ node }">
                                {{ node.raw.id }}
                              </div>
                            </treeselect>

                            <treeselect v-if="filter.type == 'treeselect' && filter.key == 'stypecode'
                            " :multiple="filter.multiple == true ? true : false" raw :show-count="true"
                              :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                              search-nested :options="stypecode_options" v-model="reports.args[filter.key]">
                              <div slot="value-label" slot-scope="{ node }">
                                {{ node.raw.id }}
                              </div>
                            </treeselect>

                            <treeselect v-if="filter.type == 'treeselect' && filter.key == 'salesgroup'
                            " :multiple="filter.multiple == true ? true : false" raw :show-count="true"
                              :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                              search-nested :options="salesgroup_options" v-model="reports.args[filter.key]">
                              <div slot="value-label" slot-scope="{ node }">
                                {{ node.raw.id }}
                              </div>
                            </treeselect>

                            <treeselect v-if="filter.type == 'treeselect' && filter.key == 'accounttype'
                            " :multiple="filter.multiple == true ? true : false" raw :show-count="true"
                              :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                              search-nested :options="accounttype_options" v-model="reports.args[filter.key]">
                              <div slot="value-label" slot-scope="{ node }">
                                {{ node.raw.id }}
                              </div>
                            </treeselect>

                            <treeselect v-if="filter.type == 'treeselect' && filter.key == 'slacgroup'
                            " :multiple="filter.multiple == true ? true : false" raw :show-count="true"
                              :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                              search-nested :options="slacgroup_options" v-model="reports.args[filter.key]">
                              <div slot="value-label" slot-scope="{ node }">
                                {{ node.raw.id }}
                              </div>
                            </treeselect>

                            <treeselect v-if="filter.type == 'treeselect' && filter.options"
                              :multiple="filter.multiple == true ? true : false" :show-count="true"
                              :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                              search-nested :options="filter.options" :placeholder="filter.placeholder"
                              v-model="reports.args[filter.key]">
                            </treeselect>

                            <treeselect v-if="filter.key == 'monthof'" :disabled="busyddl" :clearable="false"
                              v-model="reports.args[filter.key]" :options="filter.options"
                              :placeholder="filter.placeholder" />

                            <daterangepicker v-if="filter.type == 'daterangepicker'" v-model="reports.args[filter.key]"
                              :opens="'right'" :single-date-picker="'range'" :locale-data="locale_data" :ranges="instance.call == 'report_nltrial'
                                ? finance_ranges
                                : locale_ranges
                                " :linkedCalendars="true" :showDropdowns="true">
                            </daterangepicker>

                            <daterangepicker v-if="filter.type == 'daterangepicker2'" v-model="reports.args[filter.key]"
                              :opens="'right'" :single-date-picker="false" :locale-data="locale_data" :ranges="instance.call == 'report_nltrial'
                                ? finance_ranges
                                : locale_ranges
                                " :linkedCalendars="false" :showDropdowns="true">
                            </daterangepicker>

                            <v-date-picker v-if="filter.type == 'dateinput'" v-model="reports.args[filter.key]"
                              mode="date" is24hr color="green" :locale="'en-gb'" class="form-control form-control-sm">
                              <template v-slot="{ inputValue, inputEvents }">
                                <input class="
                              h-20px
                              border-none
                              focus:outline-none focus:border-primary
                              text-primary
                            " :value="inputValue" v-on="inputEvents" />
                              </template>
                            </v-date-picker>

                            <b-form-input v-if="filter.type == 'b-form-input'" type="text"
                              v-model="reports.args[filter.key]" :placeholder="placeholder(filter)"
                              :disabled="filter.disabled" size="sm" trim :debounce="reports.debounce"></b-form-input>

                            <b-form-textarea v-if="filter.type == 'b-form-textarea'" type="text"
                              v-model="reports.args[filter.key]" :placeholder="placeholder(filter)"
                              :disabled="filter.disabled" size="sm" trim :debounce="reports.debounce"></b-form-textarea>

                            <b-form-tags v-if="filter.type == 'b-form-tags'" v-model="reports.args[filter.key]"
                              tag-variant="primary" separator=" ,;" :placeholder="placeholder(filter)"
                              :disabled="filter.disabled" size="sm" class="h-29" add-button-text="+" add-on-change
                              remove-on-delete add-button-variant="outline-primary" trim
                              :debounce="reports.debounce"></b-form-tags>
                            <!-- {{filter.options}} -->
                            <!-- "{ year: 'numeric', month: 'numeric', day: 'numeric' }" -->
                            <b-form-datepicker v-if="filter.type == 'b-form-datepicker'"
                              v-model="reports.args[filter.key]" size="sm" label-help hide-header locale="en-GB"
                              :placeholder="filter.placeholder
                                ? filter.placeholder
                                : 'Select date'
                                " :disabled="filter.disabled" :date-format-options="filter.options
                                  ? filter.options
                                  : {
                                    year: 'numeric',
                                    month: 'numeric',
                                    day: 'numeric',
                                  }
                                  " :debounce="reports.debounce"></b-form-datepicker>
                            <!-- "[{ text: 'Sold Only', value: true }, { text: 'Show All', value: false }]" -->
                            <!-- {{filter.key}} -->

                            <!-- <b-input-group v-if="filter.type == 'dateinputbutton'"> -->
                            <b-input-group-prepend v-if="filter.type == 'dateinputbutton'">
                              <b-form-datepicker size="sm" v-model="reports.args[filter.key]" button-only label-help=""
                                locale="en-GB" :disabled="filter.disabled" :date-format-options="filter.options
                                  ? filter.options
                                  : {
                                    year: 'numeric',
                                    month: 'numeric',
                                    day: 'numeric',
                                  }
                                  "></b-form-datepicker>
                            </b-input-group-prepend>
                            <b-form-input v-if="filter.type == 'dateinputbutton'" size="sm"
                              v-model="reports.args[filter.key]" type="text" placeholder="DD/MM/YY" autocomplete="off"
                              :disabled="filter.disabled"></b-form-input>

                            <!--</b-input-group> -->

                            <b-form-radio-group v-if="filter.type == 'b-form-radio-group'"
                              v-model="reports.args[filter.key]" :options="filter.options" buttons
                              button-variant="outline-success" size="sm" name="radio-btn-outline"
                              :debounce="reports.debounce"></b-form-radio-group>
                            <b-input-group-append v-if="filter.clearable &&
                              filter.type != 'treeselect' &&
                              filter.type != 'b-form-radio-group'
                            ">
                              <b-button v-if="filter.type == 'daterangepicker' || filter.type == 'daterangepicker2'"
                                size="sm" variant="outline-secondary" @click="
                                  reports.args[filter.key] = {
                                    startDate: null,
                                    endDate: null,
                                  }
                                  ">
                                <i class="fa fa-remove"></i>
                              </b-button>
                              <b-button v-if="!(filter.type == 'daterangepicker' || filter.type == 'daterangepicker2')"
                                size="sm" variant="outline-secondary" @click="reports.args[filter.key] = null">
                                <i class="fa fa-remove"></i>
                              </b-button>
                            </b-input-group-append>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                    </b-row>

                  </b-collapse>
                </b-col>
              </b-row>

              <b-row align-v="end" class="nopadding my-2 mt-4 background-transparent" no-gutters
                v-if="mifields.length > 0">
                <b-col cols="12" class="text-left text-orange mt-n2 divider text-11px">
                  MI Fields
                </b-col>
              </b-row>
              <!-- {{ mifields }} -->
              <b-row class="w-100pct mt-2" v-if="mifields.length > 0">
                <b-col cols="12" sm="6" md="4" xl="3" v-for="(mifield, index) in mifields" :key="index">
                  <b-form-group :label="$helpers.requiredlabel(requirement, mifield.label)" :class="$helpers
                    .requiredlabel(requirement, mifield.label)
                    .slice(0, 1) == '*'
                    ? 'text-danger'
                    : ''
                    " label-cols="12" label-size="sm">
                    <b-input-group>
                      <b-form-input v-if="mifield.type == 'input'" type="text" :disabled="mifield.active == '0'"
                        size="sm" trim v-model="mifield.value" :placeholder="mifield.label"></b-form-input>
                      <b-input-group-append v-if="mifield.type == 'input'" @click="mifield.value = ''">
                        <b-button size="sm" variant="outline-secondary">
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                    <treeselect v-if="mifield.type == 'listofvalues'" :show-count="true" :flatten-search-results="true"
                      :clearable="true" :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                      :options="mifield.options" v-model="mifield.value">
                    </treeselect>

                  </b-form-group>
                </b-col>
              </b-row>

            </section>
            <br />
          </b-card-text>
        </b-card>
        <b-overlay :show="busy" spinner-type="grow" spinner-variant="primary" rounded="sm" class="z-0">
          <b-alert :show="reports.error ? true : false" variant="danger" class="mt-2 mb-1">
            <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
              {{ reports.error }}
            </b-row>
          </b-alert>
          <b-alert :show="reports.dirty ? true : false" variant="warning" class="mt-2 mb-1">
            <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
              <b-col>
                Click

                <b-link id="report-go" class="mt-1 mx-2 nodecoration" title="Go" @click="report">
                  <i class="fa fa-play pr-1" aria-hidden="true"></i>Go
                </b-link>
                to show the report
                <!-- <span v-html="reports.dirty"></span>  -->
              </b-col></b-row>
          </b-alert>

          <r-table :refid="reports.refid" :busy="reports.busy" :icon="reports.icon" :showtoolbar="true"
            :showsheets="true" :showpages="false" :showfab="false" :tools="reports.tools" :fields="reports.fields"
            :downloaded="reports.items" :items="reports.items" :dirty="reports.dirty" @click="reports_click"
            @select="reports_select" />


        </b-overlay>
        <b-row class="py-2">
          <b-col>
            <b-alert :show="item.requirement ? true : false" variant="danger">
              <b-row align-v="center" no-gutters>
                <b-col cols="auto mr-3">
                  <i class="fa fa-exclamation-circle fa-2x"></i>
                </b-col>
                <b-col>
                  Please input {{ item.requirement }} to display report.
                </b-col>
              </b-row>
            </b-alert>
          </b-col>
        </b-row>
      </b-card-body>

      <!-- {{ search }} <br /> -->
      <!-- {{ reports.args }}<br /> -->
      <!-- {{ item }} -->
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

import ExcelJS from "exceljs";
import * as fs from "file-saver";

export default {
  name: "Report",
  props: {
    search: { type: Object },
    refresh: { type: Object },
    showback: { type: Boolean, default: false },
  },
  watch: {
    refresh: {
      immediate: true,
      async handler(newVal, oldVal) {
        await this.load();
      },
    },
    search: {
      immediate: true,
      async handler(newVal, oldVal) {
        if (newVal) {
          // if (newVal) {
          this.instance.name = newVal.name
          this.instance.call = newVal.call
          // }
          await this.loadDDL();
        }

      },
    },
    "$route.query": {
      immediate: true,
      deep: true,
      async handler(newVal, oldVal) {
        if (newVal.name && newVal.call) {
          this.instance.name = newVal.name
          this.instance.call = newVal.call
        }
        await this.loadDDL();
      },
    },
    "item.source": {
      handler(newVal, oldVal) {
        this.load();
      },
    },
    "reports.args": {
      deep: true,
      // immediate: true,
      async handler(newVal, oldVal) {
        console.log("watch:args", newVal);
        // this.reports.message = "Click <i class='fa fa-play text-primary ml-1 mr-1'></i>Go to show the report";
        if (newVal.slac) {
          if (Array.isArray(newVal.slac)) {
            this.item.slac = newVal.slac.join(",")
          } else {
            this.item.slac = newVal.slac
          }
          this.item.tags = "{}"

          this.mifields = []
          await this.load_mifields();

          // THERE IS NO REQUIREMENT
          this.requirement = {}
        }
        this.reports.dirty = true;
        this.item.requirement = null;

      },
    },
  },
  computed: {
    ...mapGetters(["window", "user", "events"]),
  },
  data() {
    return {
      busy: false,
      busyddl: false,
      instance: {},
      textsize: "",
      snapshot_options: [{ id: "saracs_live", label: "saracs_live" }],
      nlcode_options: [],
      budgetcode_options: [],
      stypecode_options: [],
      salesgroup_options: [],
      accounttype_options: [],
      emdremarks_options: [],
      slacgroup_options: [],
      tags: {},
      showfilter: true,
      advanced: false,
      reports: {
        title: "Reports",
        icon: "fa fa-leanpub",
        debounce: 500,
        busy: false,
        dirty: false,
        page: 1,
        tools: "go,filter,download,clipboard,textsize,sheet_1",
        filters: [],
        filters_standard: [],
        filters_advanced: [],
        args: {},
        output: "grid",
        message: "",
        error: "",
      },
      item: {
        name: null,
        source: null,
        sheet: null,
        total: 0,
        requirement: null,
        comment: null,
        fields: [],
        items: [],
        sheets: [
          { id: "sheet1", label: "Sheet 1", variant: "outline-success" },
        ],
      },
    };
  },
  methods: {
    async loadDDL() {
      this.item.items = [];

      let variables = {
        call: this.instance.call,
      };

      try {
        const response = await this.$apollo.query({
          query: gql`
            query setup_reports_ddl($call: String) {
              setup_reports_ddl(call: $call) {
                report {
                  name
                  call
                  data
                }
              }
            }
          `,
          variables,
        });

        this.reports.args = {};
        if (response.data.setup_reports_ddl.report) {

          this.reports.filters = JSON.parse(
            response.data.setup_reports_ddl.report.data
          ).filters;

          this.reports.filters_standard = this.reports.filters.filter(o => o.category == 'standard')
          this.reports.filters_advanced = this.reports.filters.filter(o => o.category == 'advanced')

          if (this.reports.filters_standard.length == 0) { this.reports.filters_standard = this.reports.filters }

          for (var i = 0; i < this.reports.filters.length; i++) {
            if (this.reports.filters[i].hasOwnProperty("value")) {
              this.$set(
                this.reports.args,
                this.reports.filters[i].key,
                this.reports.filters[i].value
              );
            }
          }
        }
      } catch (error) {
        error.message = " its gone wrong"
      }
      this.snapshot_options = [{ id: "saracs_finance", label: "saracs_finance" }];
      for (var k = 1; k < 7; k++) {
        this.snapshot_options.push({
          id: "saracs_finance_" + this.$moment().subtract(k, "months").format("YYYYMM"),
          label: "saracs_finance_" + this.$moment().subtract(k, "months").format("YYYYMM"),
        });
      }

      try {
        const response = await this.$apollo.query({
          query: gql`
            query nlcodes {
              nlcodes {
                id
                label
              }
            }
          `,
        });
        this.nlcode_options = response.data.nlcodes;
      } catch (error) {
        console.log(error);
      }

      try {
        const response = await this.$apollo.query({
          query: gql`
            query setup_emdremarks ($descriptionddl: String) {
              setup_emdremarks (descriptionddl: $descriptionddl) {
                id: description
                label: description
              }
            }
          `,
          variables: { descriptionddl: "yes" }
        });
        this.emdremarks_options = response.data.setup_emdremarks;
      } catch (error) {
        console.log(error);
      }

      try {
        const response = await this.$apollo.query({
          query: gql`
              query setup_budgets {
                setup_budgets {
                  id
                  label
                }
              }
            `,
        });
        this.budgetcode_options = response.data.setup_budgets;
      } catch (error) {
        console.log(error);
      }

      try {
        const response = await this.$apollo.query({
          query: gql`
            query suppliertypes {
              suppliertypes {
                id
                label
                faicon
              }
            }
          `,
        });
        //this.stypecode_options = response.data.suppliertypes;
        this.stypecode_options = response.data.suppliertypes.filter(o => o.faicon != '');
      } catch (error) {
        console.log(error);
      }

      try {
        const response = await this.$apollo.query({
          query: gql`
            query salesgroups {
              salesgroups {
                id
                label
              }
            }
          `,
        });
        this.salesgroup_options = response.data.salesgroups;
      } catch (error) {
        console.log(error);
      }

      try {
        const response = await this.$apollo.query({
          query: gql`
            query clientaccounttypes {
              clientaccounttypes {
                id
                label
              }
            }
          `,
        });
        this.accounttype_options = response.data.clientaccounttypes;
      } catch (error) {
        console.log(error);
      }

      try {
        const response = await this.$apollo.query({
          query: gql`
            query setup_clientgroups {
              setup_clientgroups {
                id: code
                label
              }
            }
          `,
        });
        this.slacgroup_options = response.data.setup_clientgroups;
      } catch (error) {
        console.log(error);
      }

    },
    async load() { },
    async report() {
      this.busy = true;
      this.reports.dirty = false;
      this.reports.error = null

      this.item.fields = [];
      this.item.items = [];

      this.tags = this.item.tags

      let variables = {
        source: this.source,
        name: this.instance.call,
        format: this.reports.output,
        sheet: this.reports.report_sheet,
        options: JSON.stringify(this.reports.args),
        filters: JSON.stringify(this.reports.filters),
        tags: JSON.stringify(this.item.tags)
      };
      console.log("report variables: ", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
            query setup_report_output(
              $source: String
              $format: String
              $name: String
              $sheet: String
              $options: String
              $filters: String
              $tags: String
            ) {
              setup_report_output(
                source: $source
                format: $format
                name: $name
                sheet: $sheet
                options: $options
                filters: $filters
                tags: $tags
              ) {
                name
                source
                sheet
                total
                requirement
                comment
                fields
                items
                sheets
                excel
              }
            }
          `,
          variables,
        });

        if (response.errors) {
          this.reports.error = response.errors[0].message
        } else {
          this.item = {
            name: null,
            source: null,
            sheet: null,
            total: 0,
            requirement: null,
            comment: null,
            fields: [],
            items: [],
            sheets: [
              { id: "sheet1", label: "Sheet 1", variant: "outline-success" },
            ],
          };

          if (response.data.setup_report_output) {
            this.item = {
              name: response.data.setup_report_output.name,
              source: response.data.setup_report_output.source,
              sheet: response.data.setup_report_output.sheet,
              total: response.data.setup_report_output.total,
              requirement: response.data.setup_report_output.requirement,
              comment: response.data.setup_report_output.comment,
              fields: JSON.parse(response.data.setup_report_output.fields),
              items: JSON.parse(response.data.setup_report_output.items),
              sheets: JSON.parse(response.data.setup_report_output.sheets),
              tags: this.item.tags
            };

            this.reports.fields = JSON.parse(response.data.setup_report_output.fields);
            this.reports.items = JSON.parse(response.data.setup_report_output.items);

            if (this.reports.output == "excel") {
              console.log("outputting excel");
              let workbook = new ExcelJS.Workbook();
              workbook.model = JSON.parse(response.data.setup_report_output.excel);
              workbook.created = new Date();
              workbook.modified = new Date();
              console.log(workbook);
              let buffer = await workbook.xlsx.writeBuffer();
              fs.saveAs(
                new Blob([buffer], { type: "application/octet-stream" }),
                response.data.setup_report_output.name +
                this.$moment().format("_YYYYDDMMHHMMSS") +
                ".xlsx"
              );
            }
          }
        }
      } catch (error) {
        console.log(error.message)
        this.reports.error = error.message

      }
      // this.reports.message = "";
      this.item.tags = this.tags
      this.busy = false;
      await this.$emit("refreshed");
    },
    async outputCSV() {
      let file = await this.outputTSV(",");

      let buffer = Buffer.from(file, "utf8");

      fs.saveAs(
        new Blob([buffer], { type: "text/csv;charset=utf-8" }),
        this.item.name + this.$moment().format("_YYYYDDMMHHMMSS") + ".csv"
      );
    },
    async outputTSV(delim) {

      if (!delim) {
        delim = "\t"
      }
      let result = "";

      let fields = this.item.fields
      let items = this.item.items

      for (let j = 0; j < items.length; j++) {
        let line = "";

        // HEADER
        if (j == 0) {
          for (let k = 0; k < fields.length; k++) {
            if (fields[k].key == "selected" || fields[k].key == "icon" || fields[k].key == "actions") {
            } else {
              line += fields[k].label + delim;
            }
          }
          if (line.length > 0) {
            line = line.slice(0, -1);
          }
          result += line + "\n";
          line = "";
        }

        let obj = items[j];

        // USE FIELDS IN CASE AN OBJECT IS NOT COMPLETE
        for (let k = 0; k < fields.length; k++) {
          let value = "";
          let prop = ""
          if (fields[k].key == "selected" || fields[k].key == "icon" || fields[k].key == "actions") {
          } else {
            value = obj[fields[k].key] || obj[fields[k].key] === 0 ? obj[fields[k].key] : ""
            value = value
              .toString()
              .replace(/(\r\n|\n|\r)/gm, "")
              .replace(/""/g, '"');
            prop = fields[k].key.toLowerCase()
            line += value + delim;
          }

        }
        if (line.length > 0) {
          line = line.slice(0, -1);
        }

        result += line + "\n";
      }

      return result;
    },
    changeTextsize() {
      if (this.textsize == "") {
        this.textsize = "bigger";
      } else if (this.textsize == "bigger") {
        this.textsize = "biggest";
      } else if (this.textsize == "biggest") {
        this.textsize = "biggest2";
      } else if (this.textsize == "biggest2") {
        this.textsize = "";
      }
    },
    label(filter) {
      if (filter.label) {
        return filter.label;
      }
      if (filter.key) {
        switch (filter.key) {
          case "event":
          case "eventcode":
            return "Event";
          case "slac":
            return "Client SL A/C";
          case "blac":
            return "Supplier BL A/C";
          case "nlcode":
            return "N/L Accounts";
          case "passenger":
            return "Passenger";
        }
      }
    },
    placeholder(filter) {
      if (filter.placeholder) {
        return filter.placeholder;
      }
      if (filter.key) {
        switch (filter.key) {
          case "passenger":
            return "Enter (Surname/Forename)";
        }
      }
    },
    rowclass(row) {
      let result = null;
      if (row) {
        if (Object.values(row).includes("Report Totals")) {
          result = "row-total";
        } else if (Object.values(row).includes("Total:")) {
          result = "row-total";
        } else if (parseInt(row.Qty) < 0 || parseInt(row.qty) < 0) {
          result = "row-debit";
        } else if (row.Total < 0 || row.total < 0) {
          result = "row-debit";
        } else if (row.Cost < 0 || row.cost < 0) {
          result = "row-debit";
        } else if (row.Amount < 0 || row.Amount < 0) {
          result = "row-debit";
        } else if (row["SL Amount"] < 0 || row["BL Amount"] < 0) {
          result = "row-debit";
        } else if (row.Miles <= 0 || row.miles <= 0) {
          result = "row-debit";
        }
      }
      return result;
    },
    async reports_click(a, ss) {

      switch (a) {
        case "filter":
          this.showfilter = !this.showfilter;
          break;
        case "discard":
        case "go":
          this.component = null;
          await this.report();
          break;

        case "clipboard":
          let x = await this.outputTSV()
          await navigator.clipboard.writeText(x);
          break;

        case "csv":
          await this.outputCSV();
          break;
      }
    },

    async reports_select(ss, tools) {

      let state = this.reports;

      state.selected = ss;
      let tool = null;

      if (tools) {
        let enabled = [
          "back",
          "save",
          "go",
          "filter",
          "textsize",
          "clipboard",
          "download",
        ];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });
        // == 1
        // enabled = ["edit", "view"];
        // enabled.forEach(function (action, index) {
        //   tool = tools.find((o) => o.action == action);
        //   if (tool) {
        //     tool.disabled = ss.length == 1 ? false : true;
        //   }
        // });
        // > 1
        // enabled = ["deleteconfirm"];
        // enabled.forEach(function (action, index) {
        //   tool = tools.find((o) => o.action == action);
        //   if (tool) {
        //     tool.disabled = ss.length > 0 ? false : true;
        //   }
        // });

        if (!state.denied) {
          state.denied = [];
        }
        state.denied.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.visible = false;
          }
        });
      }
    },
  },
};
</script>

<style></style>